
import common from './ko/common';
import home from './ko/home';
import airports from './ko/airports';
import profiles from './ko/profiles';
import settings from './ko/settings';
import reviews from './ko/reviews';
import inventory from './ko/inventory';
import auth from './ko/auth';
import navigation from './ko/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
